
import React from 'react';

const MonitorList = () => <div>TBD</div>;

export default MonitorList;
